// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--10-2!../../postcss-loader/index.js??postcss!../../sass-loader/lib/loader.js??ref--10-4!./ionicons.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js??ref--10-2!../../postcss-loader/index.js??postcss!../../sass-loader/lib/loader.js??ref--10-4!./ionicons.scss", function() {
			var newContent = require("!!../../css-loader/index.js??ref--10-2!../../postcss-loader/index.js??postcss!../../sass-loader/lib/loader.js??ref--10-4!./ionicons.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/scss/ionicons.scss
// module id = 436
// module chunks = 17